import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numberSpace' })
export class NumberSpacePipe implements PipeTransform {
  transform(value: number): string {
    return value.toLocaleString('fr').replace(/\u202F/g, ' ');
  }
}
